export const   homemeal=[
    {
      "quantity":1,
      "id":39,
    "name":"Classic Biryani Combo",
    "detail":"Large portions of Biryani rice with 2 pc Hot & Crispy, 2 Gravies, 4 Strips & Pepsi PET",
    "price":740.00,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002166.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":40,
    "name":"Chick’n Wings Combo",
    "detail":"Enjoy 2pc Hot & Crispy Chicken, 4 wings , 2 dips & a chilled Pepsi Black",
    "price":450.48,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002000.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":41,
    "name":"Classic Zinger Meal",
    "detail":"Favorite combo of Classic Zinger Burger, Medium Fries & a chilled Pepsi Black",
    "price":344.76,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002001.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":42,
    "name":"Super Snacker Combo",
    "detail":"Best of snacks with a Medium Popcorn, 4 strips, 1 dip & a chilled Pepsi Black",
    "price":450.48,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002168.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":43,
    "name":"Family Feast",
    "detail":"Family Deal of 3 chicken zingers, a medium popcorn, medium fries & a chilled Pepsi PET",
    "price":828.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00000974.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":44,
    "name":"Stay Home Bucket",
    "detail":"Save 21% on 4pc Hot & Crispy, 4 Wings, 6 Chicken Strips & 2 dips",
    "price":788.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002169.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":45,
    "name":"Chick'n Strips Solo Combo",
    "detail":"Go solo with 1 pc Hot & Crispy, 3 strips, Medium Fries & a chilled Pepsi Black",
    "price":419.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002170.jpg?ver=20.85"
    }
    ]